import React, { useState } from "react";
import {
  Container,
  Row,
  Col,
  Form,
  Button,
  Alert,
  Spinner,
  Card,
} from "react-bootstrap";
import { useResetPasswordMutation } from "../slices/userApiSlice";

import { FaPhoneAlt, FaLock, FaEye, FaEyeSlash } from "react-icons/fa";

const ForgotPasswordScreenWeb = () => {
  const [phone, setPhone] = useState("");
  const [newPassword, setNewPassword] = useState("");
  const [showPassword, setShowPassword] = useState(false); // 👈 added
  const [successMessage, setSuccessMessage] = useState("");
  const [errorMessage, setErrorMessage] = useState("");

  const [resetPassword, { isLoading }] = useResetPasswordMutation();

  const validatePhone = (phone) => /^[6-9]\d{9}$/.test(phone);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setSuccessMessage("");
    setErrorMessage("");

    if (!validatePhone(phone)) {
      setErrorMessage("⚠ Please enter a valid 10-digit Indian phone number");
      return;
    }
    if (newPassword.length < 6) {
      setErrorMessage("⚠ Password should be at least 6 characters");
      return;
    }

    try {
      const res = await resetPassword({ phone, newPassword }).unwrap();
      setSuccessMessage(res.message);
      setPhone("");
      setNewPassword("");
    } catch (err) {
      setErrorMessage(err?.data?.message || "❌ Failed to reset password");
    }
  };

  return (
    <Container className="my-5">
      <Row className="justify-content-center">
        <Col xs={12} sm={10} md={6} lg={4}>
          <Card className="shadow-lg p-4" style={{ borderRadius: "18px" }}>
            <h3 className="text-center mb-4 fw-bold" style={{ color: "#007bff" }}>
              🔐 Forgot Password
            </h3>

            <Form onSubmit={handleSubmit}>
              {/* Phone Input */}
              <Form.Group className="mb-3">
                <Form.Label className="fw-semibold">
                  <FaPhoneAlt className="me-2 text-primary" /> Registered Phone
                </Form.Label>
                <Form.Control
                  type="text"
                  placeholder="Enter 10-digit phone number"
                  value={phone}
                  onChange={(e) => setPhone(e.target.value)}
                  maxLength={10}
                  required
                  style={{ borderRadius: "12px" }}
                />
              </Form.Group>

              {/* Password + Toggle Button */}
              <Form.Group className="mb-3 position-relative">
                <Form.Label className="fw-semibold">
                  <FaLock className="me-2 text-success" /> New Password
                </Form.Label>

                <Form.Control
                  type={showPassword ? "text" : "password"} // 👈 toggle
                  placeholder="Enter new password"
                  value={newPassword}
                  onChange={(e) => setNewPassword(e.target.value)}
                  required
                  style={{ borderRadius: "12px", paddingRight: "40px" }}
                />

                {/* Eye / EyeSlash Icon */}
                <span
                  onClick={() => setShowPassword(!showPassword)}
                  style={{
                    position: "absolute",
                    right: "12px",
                    top: "55%",
                    cursor: "pointer",
                    color: "#555",
                  }}
                >
                  {showPassword ? <FaEyeSlash size={18} /> : <FaEye size={18} />}
                </span>
              </Form.Group>

              {/* Submit Button */}
              <div className="d-grid mt-4">
                <Button
                  variant="gradient"
                  type="submit"
                  disabled={isLoading}
                  style={{
                    borderRadius: "14px",
                    background: "linear-gradient(90deg, #0061ff, #60efff)",
                    color: "white",
                    border: "none",
                    fontWeight: "600",
                    padding: "10px",
                  }}
                >
                  {isLoading ? (
                    <>
                      <Spinner as="span" animation="border" size="sm" /> Updating...
                    </>
                  ) : (
                    "Update Password"
                  )}
                </Button>
              </div>
            </Form>

            {successMessage && (
              <Alert
                variant="success"
                className="mt-3 text-center fw-bold"
                style={{ borderRadius: "12px" }}
              >
                ✅ {successMessage}
              </Alert>
            )}

            {errorMessage && (
              <Alert
                variant="danger"
                className="mt-3 text-center fw-bold"
                style={{ borderRadius: "12px" }}
              >
                {errorMessage}
              </Alert>
            )}
          </Card>
        </Col>
      </Row>
    </Container>
  );
};

export default ForgotPasswordScreenWeb;
